import { render, staticRenderFns } from "./BuyFromJCICreate.vue?vue&type=template&id=5dfa3c90"
import script from "./BuyFromJCICreate.vue?vue&type=script&lang=js"
export * from "./BuyFromJCICreate.vue?vue&type=script&lang=js"
import style0 from "./BuyFromJCICreate.vue?vue&type=style&index=0&id=5dfa3c90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports